import * as React from 'react';
import {InputGroup} from 'react-bootstrap';
import {SketchPicker} from 'react-color';
import Form from 'react-bootstrap/Form';
import css from './ColorPicker.module.css';

export default class ColorPicker extends React.Component {
  rootElRef = null;

  _hidePickerOnOutsideClick = (event) => {
    if (this.state.showColorPicker && !this.rootElRef?.contains(event.target)) {
      this.setState({showColorPicker: false});
    }
  };

  _openColorPicker = () => {
    let shouldOpenToTop = false;
    if (this.rootElRef) {
      const rect = this.rootElRef.getBoundingClientRect();
      shouldOpenToTop = window.innerHeight - rect.bottom < 300;
    }
    this.setState({
      showColorPicker: !this.state.showColorPicker,
      shouldOpenToTop,
    });
  };

  constructor(props) {
    super(props);
    this.state = {showColorPicker: false, shouldOpenToTop: false};

    document.addEventListener('click', this._hidePickerOnOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this._hidePickerOnOutsideClick);
  }

  render() {
    return (
      <div ref={(el) => (this.rootElRef = el)} className={css.root}>
        <InputGroup onClick={this._openColorPicker}>
          <InputGroup.Prepend>
            <InputGroup.Prepend>
              <InputGroup.Text
                style={{
                  color: this.props.color,
                  backgroundColor: this.props.color,
                }}
              >
                &nbsp;&nbsp;&nbsp;
              </InputGroup.Text>
            </InputGroup.Prepend>
          </InputGroup.Prepend>
          <Form.Control readOnly value={this.props.color} />
        </InputGroup>

        {this.state.showColorPicker && (
          <SketchPicker
            className={this.state.shouldOpenToTop ? css.topPicker : css.picker}
            onClose={() => this.setState({showColorPicker: false})}
            color={this.props.color}
            onChangeComplete={(color) => {
              if (this.props.disableOpacity) {
                this.props.onChangeComplete(color.hex);
              } else {
                if (color.rgb.a === 0) {
                  this.props.onChangeComplete('#00000000');
                } else {
                  this.props.onChangeComplete(
                    color.hex + Math.floor(color.rgb.a * 255).toString(16)
                  );
                }
              }
            }}
            onChange={(color) => {
              if (this.props.disableOpacity) {
                this.props.onChangeComplete(color.hex);
              } else {
                if (color.rgb.a === 0) {
                  this.props.onChangeComplete('#00000000');
                } else {
                  this.props.onChangeComplete(
                    color.hex + Math.floor(color.rgb.a * 255).toString(16)
                  );
                }
              }
            }}
          />
        )}
      </div>
    );
  }
}
